/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React, { createContext, useContext, useRef } from 'react';
import { Product } from '../types/Products.ts'; // Import from the new types file

interface ProductsCacheContextType {
  cache: React.MutableRefObject<Map<string, Product[]>>;
}

const ProductsCacheContext = createContext<ProductsCacheContextType | null>(null);

export const ProductsCacheProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const cache = useRef<Map<string, Product[]>>(new Map());
  
  return (
    <ProductsCacheContext.Provider value={{ cache }}>
      {children}
    </ProductsCacheContext.Provider>
  );
};

export const useProductsCache = () => {
  const context = useContext(ProductsCacheContext);
  if (!context) {
    throw new Error('useProductsCache must be used within ProductsCacheProvider');
  }
  return context.cache;
};
